import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';
import {
	generalConfigurationId as selectedWorkflowGeneralConfigurationId,
	userSpecificConfigurationId as selectedWorkflowUserSpecificConfigurationId,
} from '../selectedWorkflow/modules/configurations/getters';

const buildConfigurationEditorGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const generalConfigurationId = buildConfigurationEditorGetterObject('generalConfigurationId');
export const useConfigurationsValues = buildConfigurationEditorGetterObject('useConfigurationsValues');
export const userSpecificConfigurationId = buildConfigurationEditorGetterObject('userSpecificConfigurationId');
export const configurationsValuesByFieldUUID = buildConfigurationEditorGetterObject('configurationsValuesByFieldUUID');

const getters = {
	[generalConfigurationId.getter]: (state, getters, rootState, rootGetters) => rootGetters[selectedWorkflowGeneralConfigurationId.fullPath],
	[useConfigurationsValues.getter]: (state) => state.configurationsValues,
	[configurationsValuesByFieldUUID.getter]: (state) => {
		const configurationsValues = state.configurationsValues;
		let configurationsInterfacesValues = {};
		for (const configurationId in configurationsValues) {
			const configurationInterfaces = configurationsValues[configurationId];
			for (const configurationInterfaceKey in configurationInterfaces) {
				const configurationInterface = configurationInterfaces[configurationInterfaceKey];
				configurationsInterfacesValues = { ...configurationsInterfacesValues, ...configurationInterface };
			}
		}
		return configurationsInterfacesValues;
	},
	[userSpecificConfigurationId.getter]: (state, getters, rootState, rootGetters) =>
		rootGetters[selectedWorkflowUserSpecificConfigurationId.fullPath],
};

export default getters;
